/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MonthStatVo } from './MonthStatVo';
import {
    MonthStatVoFromJSON,
    MonthStatVoFromJSONTyped,
    MonthStatVoToJSON,
    MonthStatVoToJSONTyped,
} from './MonthStatVo';

/**
 * 
 * @export
 * @interface InvitedMemberVo
 */
export interface InvitedMemberVo {
    /**
     * 邀新会员id
     * @type {number}
     * @memberof InvitedMemberVo
     */
    invitedUserId?: number;
    /**
     * 邀新会员名
     * @type {string}
     * @memberof InvitedMemberVo
     */
    invitedUserName?: string;
    /**
     * 邀新会员编号
     * @type {string}
     * @memberof InvitedMemberVo
     */
    invitedUserCode?: string;
    /**
     * 推荐人号码（该会员注册时填入的推荐码）
     * @type {string}
     * @memberof InvitedMemberVo
     */
    recommendCode?: string;
    /**
     * 各月份聚合数据（仅包含有佣金记录的月份，未包含的月份前端显示"-"）
     * @type {Array<MonthStatVo>}
     * @memberof InvitedMemberVo
     */
    months?: Array<MonthStatVo>;
}

/**
 * Check if a given object implements the InvitedMemberVo interface.
 */
export function instanceOfInvitedMemberVo(value: object): value is InvitedMemberVo {
    return true;
}

export function InvitedMemberVoFromJSON(json: any): InvitedMemberVo {
    return InvitedMemberVoFromJSONTyped(json, false);
}

export function InvitedMemberVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitedMemberVo {
    if (json == null) {
        return json;
    }
    return {
        
        'invitedUserId': json['invitedUserId'] == null ? undefined : json['invitedUserId'],
        'invitedUserName': json['invitedUserName'] == null ? undefined : json['invitedUserName'],
        'invitedUserCode': json['invitedUserCode'] == null ? undefined : json['invitedUserCode'],
        'recommendCode': json['recommendCode'] == null ? undefined : json['recommendCode'],
        'months': json['months'] == null ? undefined : ((json['months'] as Array<any>).map(MonthStatVoFromJSON)),
    };
}

export function InvitedMemberVoToJSON(json: any): InvitedMemberVo {
    return InvitedMemberVoToJSONTyped(json, false);
}

export function InvitedMemberVoToJSONTyped(value?: InvitedMemberVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invitedUserId': value['invitedUserId'],
        'invitedUserName': value['invitedUserName'],
        'invitedUserCode': value['invitedUserCode'],
        'recommendCode': value['recommendCode'],
        'months': value['months'] == null ? undefined : ((value['months'] as Array<any>).map(MonthStatVoToJSON)),
    };
}

